import { useAppSelector } from '../../app/hooks';
import {
  selectSessionBufferTranscriptMessages,
  selectTranscriptMessages,
} from '../../selectors/message';

function useTranscriptMessages() {
  // WS-3 (HITL-1411): the merge + sort now lives in memoized selectors, so the
  // transcript is rebuilt only when the underlying frames change — not on every
  // render (and without a `new Date()` per sort comparison).
  const messagesList = useAppSelector(selectTranscriptMessages);
  const sessionBufferMessagesList = useAppSelector(
    selectSessionBufferTranscriptMessages
  );

  return { messagesList, sessionBufferMessagesList };
}

export default useTranscriptMessages;
